export const mapParsedResumeToCandidateApplicationFormStore = (data, parseResumeStore, candidateApplicationFormStore, candidateProfileStore, ignoreContactInfo =false) => {

  const username = generateUsername(data.firstName, data.lastName);
  const location = generateCityStateCombo(data.city, data.state);

  Object.assign(candidateApplicationFormStore.newUserDetails, {
    ...ignoreContactInfo && {
      ...data.firstName && {firstName: data.firstName},
      ...data.lastName && {lastName: data.lastName},
      ...data.email && {email: data.email},
      ...data.phone && {phone: data.phone},
      ...data.city && {city: data.city},
      ...data.state && {state: data.state},
      ...data.country && {country: data.country},
      ...data.postalCode && {postalCode: data.postalCode},
      ...data.country && {country: data.country},
      ...data.lat && {lat: data.lat},
      ...data.lng && {lng: data.lng},
      ...location && {location: location},
    },
    ...username && {username: username},
    ...{tosChecked: true},
  });

  Object.assign(candidateApplicationFormStore.state, {
    ...data.education && {education: data.education},
    ...data.careerPassport && {careerPassport: data.careerPassport},
    ...data.exceptionalAbility && {exceptionalAbility: data.exceptionalAbility},
  });

  if (!candidateApplicationFormStore.applicationForm.candidate) candidateApplicationFormStore.applicationForm.candidate = {};

  Object.assign(candidateApplicationFormStore.applicationForm.candidate, {
    ...data.education && {education: data.education},
    ...data.careerPassport && {careerPassport: data.careerPassport},
    ...data.exceptionalAbility && {exceptionalAbility: data.exceptionalAbility},
  });

  mapParsedResumeToCandidateProfileStore(data, parseResumeStore, candidateProfileStore);
};

export const mapParsedResumeToCandidateProfileStore = (data, parseResumeStore, candidateProfileStore) => {
  Object.assign(candidateProfileStore.state, data, {resumeUuid: parseResumeStore.resume.uuid});
};


const generateUsername = (firstName = "", lastName= "") => {
  if (!firstName && !lastName) return "";
  const firstNameCleaned = firstName.replace(/[^a-zA-Z0-9]/g, "");
  const lastNameCleaned = lastName.replace(/[^a-zA-Z0-9]/g, "");
  const randomNumber = Math.floor(Math.random() * 10000);

  if (!firstNameCleaned && !lastNameCleaned) return "";
  if (!firstNameCleaned) return lastNameCleaned.toLowerCase();
  if (!lastNameCleaned) return firstNameCleaned.toLowerCase();

  return `${firstNameCleaned}.${lastNameCleaned}`.toLowerCase() + randomNumber;
};

const generateCityStateCombo = (city, state) => {
  if (!city && !state) return "";
  if (!city) return state;
  if (!state) return city;
  return `${city}, ${state}`;
};
